const Config = {
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL || "https://api.quantwise.ai/api/v1/",
};

export default Config;
